export default __webpack_public_path__ + "static/media/F0001.4395056c.png";